import { IProvenancesStore } from '../index'

export default function(store: IProvenancesStore): IProvenancesStore {
  return {
    ...store,
    request: {
      errMessage: '',
      isLoading: true,
    },
  }
}
